import { useUrlParams, useVerifications, useVerificationsCount } from '../../hooks';
import { ButtonFilterCountable } from '@/components/custom';
import { getSelectOptions, notify } from '@/functions';
import { useEffect, useState } from 'react';
import { useListenEvents } from '@/hooks';
import { GenderEnum } from '@/lib/enum';

type TState = Record<GenderEnum, number>;

const CONSTS = {
  initState: {
    FEMALE: 0,
    MALE: 0
  } as TState
};

const ControlsFiltersGenders = () => {

  const { countMale, countFemale, isLoadingVerificationsCount } = useVerificationsCount();
  const [state, setState] = useState<TState>(CONSTS.initState);
  const { isLoadingVerifications } = useVerifications();
  const { gender } = useUrlParams();

  useListenEvents({
    type: 'verificationStateChanged',
    callback: () => {
      setState(l => ({ ...l, [gender]: l[gender] - 1 }));
      notify('La vérification a été reporté pour traitement.');
    }
  });

  useListenEvents({
    type: 'photosVerified',
    callback: () => setState(l => ({ ...l, [gender]: l[gender] - 1 }))
  });

  useEffect(
    () => {
      setState(
        l => ({
          ...l,
          FEMALE: countFemale,
          MALE: countMale
        })
      );
    },
    [countMale, countFemale]
  );

  return (
    <div className='flex items-end space-x-2'>
      {
        getSelectOptions('GenderEnum')
          .map(
            l => (
              <ButtonFilterCountable
                enableToggle={false}
                isLoading={isLoadingVerificationsCount || isLoadingVerifications}
                count={state[l.value as GenderEnum]}
                text={`${l.title}(s)`}
                paramName='gender'
                value={l.value}
                key={l.value} />
            )
          )
      }
    </div>
  );

};

export default ControlsFiltersGenders;
